import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
  name: 'date',
  standalone: true,
})
export class DateSDPipe implements PipeTransform {
  translateService = inject(TranslateService);

  public transform(
    value: string | number | Date,
    pattern: string = 'mediumDate',
    currentLang?: string
  ): string | null {
    let ngPipe;
    if (currentLang != null) {
      ngPipe = new DatePipe(currentLang);
    } else {
      const curLang = this.translateService.currentLang;

      ngPipe = new DatePipe(curLang + '-de');
    }
    return ngPipe.transform(value, pattern);
  }
}
